import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #dee2e6;
  border-radius: 4px;
  background-color: #f8f9fa;
  text-align: center;
  height: 220px;
  width: 100%;
  color: #6c757d;
  cursor: pointer;
  transition:
    background-color 0.2s,
    border-color 0.2s;

  &:hover {
    background-color: #e9ecef;
    border-color: #ced4da;
  }
`;

export const Title = styled.h5`
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 8px;
  color: #495057;
`;

export const Subtitle = styled.p`
  font-size: 0.9rem;
  margin-top: 0;
  color: #6c757d;
`;
